import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navigationStyle: 1,
    screenWidth:document.documentElement.clientWidth, //螢幕寬度
    screenHeight:document.documentElement.clientHeight, //螢幕高度
    customizeMenuIndex: 3, // 自訂頁面 Menu focus 索引，預設 3 (公平待客)
  },
  mutations: {
    setNavigationStyle(state, int) {
      state.navigationStyle = int;
    },
    setCustomizeMenuIndex(state, index) {
      state.customizeMenuIndex = index;
    }
  },
  actions: {
  },
  modules: {
  }
})
